const DASHBOARD_PAGE_SIZE = 200;

const buildPaginatedLeadsPath = (baseQueryParams, page, limit) => {
  const params = new URLSearchParams(baseQueryParams);
  params.set('page', String(page));
  params.set('limit', String(limit));
  return `/api/leads?${params.toString()}`;
};

export const mergeUniqueLeads = (leadPages = []) => {
  const seen = new Set();
  const merged = [];

  leadPages.forEach((pageLeads) => {
    (Array.isArray(pageLeads) ? pageLeads : []).forEach((lead) => {
      const id = String(lead?._id || '');
      if (!id || seen.has(id)) return;
      seen.add(id);
      merged.push(lead);
    });
  });

  return merged;
};

export const fetchAllLeadsPages = async (apiClient, baseQueryParams, pageSize = DASHBOARD_PAGE_SIZE) => {
  const firstResponse = await apiClient.get(buildPaginatedLeadsPath(baseQueryParams, 1, pageSize));
  const firstData = firstResponse?.data || {};
  const firstPageLeads = Array.isArray(firstData.leads) ? firstData.leads : [];
  const totalPages = Math.max(Number(firstData?.pagination?.pages) || 1, 1);

  if (totalPages === 1) {
    return { ...firstData, leads: firstPageLeads };
  }

  const remainingPageNumbers = Array.from({ length: totalPages - 1 }, (_, index) => index + 2);
  const remainingResponses = await Promise.all(
    remainingPageNumbers.map((pageNumber) =>
      apiClient.get(buildPaginatedLeadsPath(baseQueryParams, pageNumber, pageSize))
    )
  );

  const remainingPages = remainingResponses.map((response) =>
    Array.isArray(response?.data?.leads) ? response.data.leads : []
  );

  return {
    ...firstData,
    leads: mergeUniqueLeads([firstPageLeads, ...remainingPages])
  };
};

